"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountdownFromTimestamp = exports.getCountdownFromDuration = void 0;
function getCountdownFromDuration(duration, inDays, asString) {
    if (inDays === void 0) { inDays = true; }
    if (asString === void 0) { asString = true; }
    var countdown = {
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00',
    };
    if (duration > 0) {
        if (inDays) {
            countdown.days = Math.floor(duration / (1000 * 60 * 60 * 24));
            duration -= countdown.days * (1000 * 60 * 60 * 24);
        }
        countdown.hours = Math.floor(duration / (1000 * 60 * 60));
        duration -= countdown.hours * (1000 * 60 * 60);
        countdown.minutes = Math.floor(duration / (1000 * 60));
        duration -= countdown.minutes * (1000 * 60);
        countdown.seconds = Math.floor(duration / (1000));
        duration -= countdown.seconds * (1000);
        for (var e in countdown) {
            if (countdown[e] < 10) {
                countdown[e] = "0".concat(countdown[e]);
            }
        }
    }
    if (asString) {
        if (inDays) {
            return "".concat(countdown.days, "D : ").concat(countdown.hours, "H : ").concat(countdown.minutes, "M : ").concat(countdown.seconds, "S");
        }
        return "".concat(countdown.hours, "H : ").concat(countdown.minutes, "M : ").concat(countdown.seconds, "S");
    }
    return countdown;
}
exports.getCountdownFromDuration = getCountdownFromDuration;
function getCountdownFromTimestamp(endTimestamp, inDays, asString, offset) {
    if (inDays === void 0) { inDays = true; }
    if (asString === void 0) { asString = true; }
    if (offset === void 0) { offset = 0; }
    if (endTimestamp instanceof Date) {
        endTimestamp = endTimestamp.getTime();
    }
    var duration = Math.max(endTimestamp - (Date.now() + offset), 0);
    return getCountdownFromDuration(duration, inDays, asString);
}
exports.getCountdownFromTimestamp = getCountdownFromTimestamp;
